import React from 'react';
import axios from 'axios';
import { useLocation } from 'react-router-dom';
import './App.css';
// import './fonts/HANDELGOTD-BOLD.TTF';
// import './fonts/HANDELGOTD-LIGH.TTF';
// import './fonts/HANDELGOTHICBT-REGULAR.TTF';
import Climate from './components/climate/climate';
import Rain from './components/rain/rain';
import Wind from './components/wind/wind';
import TrackRating from './components/trackrating/trackrating';
import SoilCompression from './components/soilcompression/soilcompression';
import WaterContent from './components/watercontent/watercontent';
import RailPosition from './components/railposition/railposition';
import SubjectTitle from './components/subtitle/subjecttitle';
import Weather from './models/weather';
import Spinner from './components/spinner/spinner';
import Logo from './components/logo/logo';

// Add global variables defined by WP
declare global {
  interface Window {
    smartWeatherAppUrl: {
      ajaxUrl: string;
      ajaxNonce: string;
    };
  }
}

const App: React.FC = () => {
  const location = useLocation();
  const path: string = location.pathname.split('/')[1] ?? '';
  // console.log(path)
  let venueId: string = '342';
  const dataVenueID = document.querySelector('#root') as HTMLElement | null;
  if (dataVenueID != null) {
    venueId = String(dataVenueID.dataset.venueid);
  }
  const [data, setData] = React.useState(new Weather());
  const [isLoading, setIsLoading] = React.useState(true);
  let nodeId: number = 0;
  switch (venueId) {
    case '342':
      nodeId = 1;
      break;
    case '349':
      nodeId = 4;
      break;
    case '854':
      nodeId = 1;
      break;
    case '420':
      nodeId = 1;
      break;
  }
  const venueIdMappings: { [key: string]: string } = {
    '342': 'atc',
    '349': 'atc',
    '854': 'atc',
    '420': 'atc'
  };
  const jurisdiction: string = venueIdMappings[venueId];

  async function fetchWeatherData() {
    try {
      const response = await axios.get(window.smartWeatherAppUrl.ajaxUrl, {
        params: {
          action: 'dashboard_ajax_endpoint',
          venueid: venueId,
          nonce: window.smartWeatherAppUrl.ajaxNonce
        },
        headers: {
          'accept': 'application/json',
        }
      });

      let weather: Weather = response.data.data;
      weather.jurisdiction = jurisdiction;
      setData({ ...data, ...weather });

      setIsLoading(false);
    } catch (error) {
      console.error('Error fetching weather data:', error);
      setIsLoading(false);
    }
  }

  React.useEffect(() => {
    fetchWeatherData();
    const intervalCall = setInterval(() => {
      fetchWeatherData();
    }, 10000);
    return () => {
      clearInterval(intervalCall);
    };
  }, [])

  return (
    <div className="App">
      <div className='row' style={{ opacity: isLoading ? 0.25 : 1 }}>
        <SubjectTitle title="" />
      </div>
      <div className="row" style={{ opacity: isLoading ? 0.25 : 1 }}>
        <div className="section">
          <Rain weather={data} />
        </div>
        <div className="section">
          <Climate weather={data} />
          <Wind weather={data} />
        </div>
      </div>
      <div className="row" style={{ opacity: isLoading ? 0.25 : 1 }}>
        <div className="section">
          <TrackRating weather={data} />
          <SoilCompression weather={data} />
        </div>
        <div className="section">
          <WaterContent weather={data} />
          <RailPosition weather={data} />
        </div>
      </div>

      {/* <div className="row" style={{opacity: isLoading ? 0.25 : 1}}>
        <div className="section">
          <Logo />
        </div>
      </div> */}
      {isLoading && <Spinner />}
    </div>
  );
}

export default App;
